/* eslint-disable */
import React from 'react';
import { color } from 'styles/colors';
import * as S from './styled';

interface SwitchToggleProps {
  isChecked: boolean;
  setIsChecked: any;
  id?: any;
  style?: any;
  colorWhenTrue?: string;
}

// Passe o estado e a função para alterar checado e não checado
export default function SwitchToggle({
  isChecked = false,
  setIsChecked,
  id = Math.random() * 10,
  style = {},
  colorWhenTrue = color.system.success,
}: SwitchToggleProps) {
  return (
    <S.containerSwitch style={{ ...style }}>
      <S.labelFather
        style={{
          backgroundColor: isChecked
            ? colorWhenTrue
            : color.interface.darkgray4,
        }}
        htmlFor={id}
        onChange={() => setIsChecked(!isChecked)}
        isChecked={isChecked}
      >
        <input
          type="checkbox"
          id={id}
          defaultChecked={isChecked}
          data-testid="switchToggleInput"
        />
        <span
          style={isChecked ? { right: '0%' } : { left: '0%' }}
          data-testid={`switchToggleInput-${isChecked}`}
        />
      </S.labelFather>
    </S.containerSwitch>
  );
}
